import parse from "html-react-parser";

import type { Faq } from "@sorcery/db";
import { P } from "@sorcery/ui";

export const FAQList = ({
  faqs,
  variant = "lg",
  className = "",
}: {
  faqs: Faq[];
  variant?: "sm" | "lg";
  className?: string;
}) => {
  return (
    <>
      {faqs.map((faq) => (
        <div key={faq.id}>
          <div className="curiosa-faq text-left">
            <P className={`!mb-2 ${className}`}>Q: {faq.question}</P>
            <div className={variant === "sm" ? "mb-2" : "mb-4"}>
              {faq.questionGrid && parse(faq.questionGrid)}
            </div>
            <P className="curiosa-faq-a">{parse(faq.answer)}</P>
            <div className={variant === "sm" ? "mb-2" : "mb-4"}>
              {faq.answerGrid && parse(faq.answerGrid)}
            </div>
          </div>
        </div>
      ))}
    </>
  );
};
